<template>
    <v-container>
        <div v-for="(order, index) in listOrder.data" :key="index">
            <div @click="cardPressed(order.orderId)">
                <sigCardInformation
                    :title="order.title"
                    :subtitles="order.subtitles"
                    :componentCurrent="component"
                    :classText="'text-h6'"
                    :classCard="'pa-0'"
                    :styleCard="
                        `border-left-style:solid; border-left-width:10px; border-left-color:${order.color};margin:10px`
                    "
                    :classSubtitle="'text-body-1'"
                ></sigCardInformation>
            </div>
        </div>
        <v-row v-if="showBtn" style="margin-top:20px; margin-bottom:10px; margin-left:0px" align="center" justify="center">
            <v-btn
                class="primary !important"
                style="color:white"
                @click="nextPage"
            >
                Carregar Mais
            </v-btn>
        </v-row>
        <v-btn
            color="primary"
            dark
            fab
            fixed
            bottom
            right
            class="btnPlus"
            @click="clickPlus"
        >
            <v-icon>
                mdi-plus
            </v-icon>
        </v-btn>
        <template>
            <div class="text-center">
                <v-bottom-sheet v-model="sheet">
                    <v-list>
                        <v-list-item
                            v-for="(option, index) in options"
                            :key="index"
                            @click="navigate(option)"
                        >
                            <v-list-item-avatar>
                                <v-icon
                                    color="primary"
                                    medium
                                >
                                    {{ option.icon }}
                                </v-icon>
                            </v-list-item-avatar>
                            <v-list-item-title>{{ option.title }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-bottom-sheet>
            </div>
        </template>
        <v-dialog
            v-model="dialog.show"
            max-width="290"
        >
            <v-card>
                <v-card-title class="headline">
                    {{dialog.title}}
                </v-card-title>

                <v-card-text>
                    {{dialog.message}}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                        color="green darken-1"
                        text
                        @click="dialog.show = false"
                    >
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="dialogFilter"
            persistent
        >
            <v-card style="padding: 15px;">
                <div>
                    <h2 class="text-center">Filtro</h2>
                    <br>

                    <v-text-field
                        v-model="filter.term"
                        label="Termo"
                        outlined
                        clearable
                        style="border-radius:12px"
                    ></v-text-field>
                    
                    <v-row>
                        <v-col 
                            cols="6"
                            sm="6"
                        >
                            <v-dialog
                                ref="dialogInitial"
                                v-model="filter.initialDate.show"
                                :return-value.sync="filter.initialDate.initialDate"
                                persistent
                                width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        :value="formatDateInitial"
                                        label="Data Inicial"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        outlined
                                        style="border-radius:12px"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    locale="pt-br"
                                    v-model="filter.initialDate.initialDate"
                                    scrollable
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="filter.initialDate.initialDate = ''; $refs.dialogInitial.save(filter.initialDate.initialDate); filter.initialDate.show = false"
                                    >
                                        Limpar
                                    </v-btn>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="filter.initialDate.show = false"
                                    >
                                        Voltar
                                    </v-btn>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.dialogInitial.save(filter.initialDate.initialDate)"
                                    >
                                        Ok
                                    </v-btn>
                                </v-date-picker>
                            </v-dialog>
                        </v-col>
                        <v-col
                            cols="6"
                            sm="6"
                        >
                            <v-dialog
                                ref="dialogEnd"
                                v-model="filter.endDate.show"
                                :return-value.sync="filter.endDate.endDate"
                                persistent
                                width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        :value="formatDateEnd"
                                        label="Data Final"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        outlined
                                        style="border-radius:12px"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    locale="pt-br"
                                    v-model="filter.endDate.endDate"
                                    scrollable
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="filter.endDate.endDate = ''; $refs.dialogEnd.save(filter.endDate.endDate); filter.endDate.show = false"
                                    >
                                        Limpar
                                    </v-btn>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="filter.endDate.show = false"
                                    >
                                        Voltar
                                    </v-btn>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.dialogEnd.save(filter.endDate.endDate)"
                                    >
                                        Ok
                                    </v-btn>
                                </v-date-picker>
                            </v-dialog>
                        </v-col>
                    </v-row>

                    <simple-select 
                        :model="filter.client.clientSelected"
                        label="Cliente"
                        :items="filter.client.listClients"
                        v-on:valueChanged="changeClient"
                    ></simple-select>
                    <simple-select 
                        :model="filter.operator.operatorSelected"
                        label="Responsável"
                        :items="filter.operator.listOperators"
                        v-on:valueChanged="changeOperator"
                    ></simple-select>
                    <simple-select 
                        :model="filter.status.statusSelected"
                        :label=labelDepartment
                        :items="filter.status.listStatus"
                        v-on:valueChanged="changeStatus"
                    ></simple-select>

                    <h3>Status</h3>
                    <v-checkbox
                        v-model="filter.statusDefaultSelected"
                        label="Em Orçamento"
                        value=0
                    ></v-checkbox>
                    <v-checkbox
                        style="margin-top: 0px;"
                        v-model="filter.statusDefaultSelected"
                        label="Orçamento Cancelado"
                        value=1
                    ></v-checkbox>
                    <v-checkbox
                        style="margin-top: 0px;"
                        v-model="filter.statusDefaultSelected"
                        label="Pedido em Andamento"
                        value=2
                    ></v-checkbox>
                    <v-checkbox
                        style="margin-top: 0px;"
                        v-model="filter.statusDefaultSelected"
                        label="Pedido Cancelado"
                        value=3
                    ></v-checkbox>
                    <v-checkbox
                        style="margin-top: 0px;"
                        v-model="filter.statusDefaultSelected"
                        label="Pedido Finalizado"
                        value=4
                    ></v-checkbox>
                                        
                    <v-row align="center" justify="center" style="margin-bottom:10px;">
                        <v-btn
                            color="primary"
                            style="color:white"
                            @click="applyFilter"
                        >
                            Filtrar
                        </v-btn>
                    </v-row>
                </div>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import CardInformation from "../../../components/card/CardInformation";
import TextCard from "../../../components/card/TextCard";
import CrudService from '../../../services/CrudService';
import SimpleSelect from '../../../components/selects/SimpleSelect';
import moment from 'moment';

export default {

    components: {
        "sigCardInformation": CardInformation,
        "simple-select": SimpleSelect
    }, 

    data: () => ({
        listOrder: {
            page: 0,
            data: []
        },
        dialog: {
            show: false,
            title: '',
            message: ''
        },
        showBtn: false,
        component: TextCard,
        sheet: false,
        options: [],
        loginData: JSON.parse(localStorage.getItem("loginData")),
        dialogFilter: false,
        filter:{
            term: "",
            statusDefaultSelected: ["0","1","2","3","4"],
            initialDate: {
                show: false,
                initialDate: ""   
            },
            endDate: {
                show: false,
                endDate: ""
            },
            client: {
                clientSelected: {text: "TODOS", value: null},
                listClients: [
                    {text: "TODOS", value: null}
                ],
            },
            status: {
                statusSelected: {text: "TODOS", value: null},
                listStatus: [
                    {text: "TODOS", value: null}
                ],
            },
            operator: {
                operatorSelected: {text: "TODOS", value: null},
                listOperators: [
                    {text: "TODOS", value: null}
                ],
            },
        },
        labelDepartment: ""
    }),

    computed: {
        formatDateInitial() {
            return this.filter.initialDate.initialDate
            ? moment(this.filter.initialDate.initialDate).format("DD/MM/YYYY")
            : "";
        },
        formatDateEnd() {
            return this.filter.endDate.endDate
            ? moment(this.filter.endDate.endDate).format("DD/MM/YYYY")
            : "";
        }
    },

    methods:{
        navigate(option){
            if(option.go != "filter"){
                if(option.go == "addUpdateOrder"){
                    localStorage.setItem("orderId", 0);
                }
                this.$router.push(option.go);
            }
            else{
                document.getElementsByTagName("body")[0].className="noscroll";
                this.dialogFilter = true;
            }
            this.sheet = false;
        },
        async getOrder(){
            let loader = this.$loading.show();
            
            try
            {
                let crudService = new CrudService();
                let result;

                let label = this.loginData.labels.find((lbl) => {
                    return lbl.typeLabel == 17
                });

                let labelDate = this.loginData.labels.find((lbl) => {
                    return lbl.typeLabel == 2
                });

                let menu = this.loginData.permissionAndMenu.find((men) => {
                    return men.menuId == 188
                });
                
                if(menu != null)
                    this.labelDepartment = menu.name;
                else
                    this.labelDepartment = "Status";

                let hasFilter = false;
                let url = "";

                if(this.filter.term.trim() != ""){
                    hasFilter = true;
                    url += `&text=${this.filter.term}`
                }
                if(this.filter.initialDate.initialDate != ""){
                    hasFilter = true;
                    url += `&initialDate=${moment(this.filter.initialDate.initialDate).format("YYYY/MM/DD 00:00:00")}`;
                }
                if(this.filter.endDate.endDate != ""){
                    hasFilter = true;
                    url += `&endDate=${moment(this.filter.endDate.endDate).format("YYYY/MM/DD 00:00:00")}`;
                }
                if(this.filter.status.statusSelected.value != null){
                    hasFilter = true;
                    url += `&status=${this.filter.status.statusSelected.value}`;
                }
                if(this.filter.client.clientSelected.value != null){
                    hasFilter = true;
                    url += `&clientId=${this.filter.client.clientSelected.value}`;
                }
                if(this.filter.operator.operatorSelected.value != null){
                    hasFilter = true;
                    url += `&responsible=${this.filter.operator.operatorSelected.value}`;
                }
                if(this.filter.statusDefaultSelected.length > 0){
                    hasFilter = true;
                    this.filter.statusDefaultSelected.forEach(status => {
                        url += `&department=${status}`;
                    });
                }

                if(hasFilter){
                    result = await crudService.get(`order/getOrderFilter?SignatureId=${this.loginData.userData.signatureId}&PersonId=${this.loginData.userData.personId}&Page=${this.listOrder.page}${url}`, this.loginData.token);
                }
                else{
                    result = await crudService.get(`order?SignatureId=${this.loginData.userData.signatureId}&PersonId=${this.loginData.userData.personId}&Page=${this.listOrder.page}`, this.loginData.token);
                }               
                
                if(result.status == 200){
                    this.listOrder.data = [...this.listOrder.data, ...result.data.map(obj => {
                        return {
                            title: `${label != null && label.name != null ? label.name : "Pedido"}: ${obj.code}`,
                            subtitles: [
                                {key: "Cliente:", value: obj.client},
                                {key: `${this.labelDepartment}:`, value: obj.status},
                                {key: `${labelDate != null && labelDate.name != null ? labelDate.name : "Retirada"}:`, value: obj.dateOfWithdrawal == null ? "NÃO DEFINIDO" : moment(obj.dateOfWithdrawal).format("DD/MM/YYYY")},
                            ],
                            color: obj.color,
                            orderId: obj.orderId
                        }
                    })];
                    this.listOrder.page = this.listOrder.page + 25;
                    this.showBtn = true;
                }
                else if(result.status == 204){
                    this.listOrder.data = [...this.listOrder.data];

                    if(this.listOrder.data.length == 0){
                        this.dialog.title = `Sem ${label != null && label.name != null ? label.name : "Pedido" }`;
                        this.dialog.message = `Ainda não há nenhum ${label != null && label.name != null ? label.name : "Pedido" } para ser listado.`;
                        this.dialog.show = true;
                        this.showBtn = false;
                    }
                    else{
                        this.showBtn = false;
                    }
                }
                else if(result.status == 401){
                    localStorage.removeItem("loginData");
                    this.$router.push({name: 'Login', params: {logout: true}});
                }
                else if(result.status == 400){
                    this.dialog.title = "Erro";
                    this.dialog.message = result.data[0];
                    this.dialog.show = true;
                }
                else if(result.status != 204){
                    this.dialog.title = "Erro";
                    this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                    this.dialog.show = true;
                }

                let resultClients = await crudService.get(`comboOrder/getComboClients/${this.loginData.userData.personId}`, this.loginData.token);
                
                if(resultClients.status == 200){
                    this.filter.client.listClients = [
                        {text: "TODOS", value: null},
                        ...resultClients.data.map(client => {
                            return {
                                text: client.name,
                                value: client.clientId 
                            }
                        })
                    ];
                }
                else if(resultClients.status == 401){
                    localStorage.removeItem("loginData");
                    this.$router.push({name: 'Login', params: {logout: true}});
                }
                else if(resultClients.status == 400){
                    this.dialog.title = "Erro";
                    this.dialog.message = resultClients.data[0];
                    this.dialog.show = true;
                }
                else if(resultClients.status != 204){
                    this.dialog.title = "Erro";
                    this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                    this.dialog.show = true;
                }

                let resultStatus = await crudService.get(`comboOrder/getComboStatus/${this.loginData.userData.signatureId}`, this.loginData.token);
                
                if(resultStatus.status == 200){
                    this.filter.status.listStatus = [
                        {text: "TODOS", value: null},
                        ...resultStatus.data.map(status => {
                            return {
                                text: status.name,
                                value: status.statusId
                            }
                        })
                    ]
                }
                else if(resultStatus.status == 401){
                    localStorage.removeItem("loginData");
                    this.$router.push({name: 'Login', params: {logout: true}});
                }
                else if(resultStatus.status == 400){
                    this.dialog.title = "Erro";
                    this.dialog.message = resultStatus.data[0];
                    this.dialog.show = true;
                }
                else if(resultStatus.status != 204){
                    this.dialog.title = "Erro";
                    this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                    this.dialog.show = true;
                }
                
                let resultOperators = await crudService.get(`comboOrder/GetComboResponsible/${this.loginData.userData.signatureId}`, this.loginData.token);
            
                if(resultOperators.status == 200){
                    this.filter.operator.listOperators = [
                        {text: "TODOS", value: null},
                        ...resultOperators.data.map(operator => {
                            return {
                                text: operator.name,
                                value: operator.id
                            }
                        })
                    ]
                }
                else if(resultOperators.status == 401){
                    localStorage.removeItem("loginData");
                    this.$router.push({name: 'Login', params: {logout: true}});
                }
                else if(resultOperators.status == 400){
                    this.dialog.title = "Erro";
                    this.dialog.message = resultOperators.data[0];
                    this.dialog.show = true;
                }
                else if(resultOperators.status != 204){
                    this.dialog.title = "Erro";
                    this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                    this.dialog.show = true;
                }

                loader.hide();
            }
            catch
            {
                loader.hide();
                this.dialog.title = "Erro";
                this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
                this.dialog.show = true;
            }
        },
        changeClient(client){
            if(typeof client === 'object')
                this.filter.client.clientSelected = client;
            else
                this.filter.client.clientSelected = {text: "TODOS", value: null};
        },
        changeOperator(operator){
            if(typeof operator === 'object')
                this.filter.operator.operatorSelected = operator;
            else
                this.filter.operator.operatorSelected = {text: "TODOS", value: null};
        },
        changeStatus(status){
            if(typeof status === 'object')
                this.filter.status.statusSelected = status;
            else
                this.filter.status.statusSelected = {text: "TODOS", value: null};
        },
        async nextPage(){
            await this.getOrder();
        },
        cardPressed(orderId){
            localStorage.setItem("orderId", orderId);
            this.$router.push('addUpdateOrder');
        },
        clickPlus(){
            if(this.options.length > 0)  
                this.sheet = true;
            else
            {
                localStorage.setItem("orderId", 0);
                this.$router.push('addUpdateOrder');
            }
        },
        async applyFilter(){
            this.listOrder.data = [];
            this.listOrder.page = 0;
            await this.getOrder();

            document.body.removeAttribute("class","noscroll");
            this.dialogFilter = false;
        }
    },

    async created(){

        let canOrder = this.loginData.permissionAndMenu.find(permission => {
            return permission.menuId == 216 || permission.menuId == 249
        });

        let canOrderSignature = this.loginData.permissionsSignature.find(permission => {
            return permission == 6 || permission == 11
        });

        if(canOrder == null || canOrderSignature == null)
            this.$router.push('menu');
        else{
            let label = this.loginData.labels.find((lbl) => {
                return lbl.typeLabel == 17
            });
            
            this.options.push({ icon: 'mdi-cart-plus', title: `Novo ${label != null && label.name != null ? label.name : "Pedido" }`, go: "addUpdateOrder" });   
            this.options.push({ icon: 'mdi-filter', title: "Filtrar", go: "filter" });
            
            let canPdv  = this.loginData.permissionAndMenu.find((p) => {
                return p.menuId == 249
            });

            if(canPdv != null){
                this.options.push({ icon: 'mdi-cash-multiple', title: "PDV", go: "pdv" });
            }

            await this.getOrder();
        }
    }
}
</script>
<style>
.btnPlus {
    margin-bottom:50px;
}
.noscroll{
    position: fixed;
    overflow-x: hidden;
    overflow-y: hidden;
    width: 100%;
}
/* iphone X , XS, 11 Pro, 12 Mini */
@media only screen and (min-width: 375px) and (max-height: 812px) and (-webkit-device-pixel-ratio: 3) { 
    .btnPlus {
        margin-bottom:80px;
    }
}

/* iphone 12, 12 Pro */
@media only screen and (min-width: 390px) and (max-height: 844px) and (-webkit-device-pixel-ratio: 3) {
    .btnPlus {
        margin-bottom:80px;
    }
}

/* iphone XR, 11 */
@media only screen and (min-width : 414px) and (max-height : 896px) and (-webkit-device-pixel-ratio : 2) { 
    .btnPlus {
        margin-bottom:80px;
    }
}
    
/* iphone XS Max, 11 Pro Max */
@media only screen and (min-width : 414px) and (max-height : 896px) and (-webkit-device-pixel-ratio : 3) { 
    .btnPlus {
        margin-bottom:80px;
    }
}

/* iphone 12 Pro Max */
@media only screen and (min-width : 428px) and (max-height : 926px) and (-webkit-device-pixel-ratio : 3) { 
    .btnPlus {
        margin-bottom:80px;
    }
}
</style>